<script setup lang="ts">
import { Handle, Position } from '@vue-flow/core';
import { useFormStore } from '@/store/form/formStore';
import { Form } from '@/models/Form';
import { entityTypes } from '@/enums/generic';
import { useLayoutStore } from '@/store/layout/layoutStore';

const onAddRoom = () => {
  const currentNode = useLayoutStore()?.currentNode;
  if (!currentNode) {
    console.error('No current node found');
  } else {
    useFormStore().createEntity(
      new Form().setParentId(currentNode.id).setName(entityTypes.room)
    );
  }
};
</script>

<template>
  <button class="node-add-room" data-testId="addRoomButton" @click="onAddRoom">
    <em class="mdi mdi-plus pl-1 pr-1 text-3xl text-primary-2"></em>
    <Handle
      id="addRoomTarget"
      type="target"
      :position="Position.Bottom"
      style="opacity: 0; bottom: 4px"
    />
  </button>
</template>
